<template>
  <div class="footer main">
      <!-- footer area start -->
        <section class="footer__area footer-bg">
            <div class="footer__top pt-50 pb-30">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-xs-6">
                            <div class="footer__widget mb-30">
                                <div class="footer__widget-title mb-25">
                                    <a class="footlogo">
                                      <img v-if="logourlshop" :src="allurl +logourlshop" alt="logo">
                                      <img v-else  style="width:auto" src="../assets/img/logo/logo-2.png" alt="logo">
                                      <!-- <img style="width:auto" src="../assets/img/logo/logo-2.png" alt="logo"> -->
                                    </a>
                                </div>
                                
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-5 col-xs-12 ">
                          <div class="footer__widget-content">
                                     <div class="footer__widget-title text-left">
                                        <h5>Information</h5>
                                    </div>
                                    <!-- <p>Outstock is a premium Templates theme with advanced admin module. It’s extremely customizable, easy to use and fully responsive and retina ready.</p> -->
                                    <div class="footer__contact text-left">
                                        <ul>
                                            <li>
                                                <div class="icon">
                                                    <i class="fa fa-map-marker"></i>
                                                </div>
                                                <div class="text">
                                                  
                                                    <span class="nowarp">Add:<p style="margin-bottom:0">{{concact}}</p> {{addressinfo.title}}</span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon">
                                                    <i class="fa fa-envelope-open"></i>
                                                </div>
                                                <div class="text">
                                                    <span>Email: {{addressinfo.email}}</span>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon">
                                                    <i class="fa fa-phone"></i>
                                                </div>
                                                <div class="text">
                                                    <span>Phone Number: {{addressinfo.phone}}</span>
                                                </div>
                                            </li>
                                        </ul>
                                        <div class="footer__social hidden hidden-sm-and-down col-xl-6 text-right" >
                                          <ul style="" class="row">
                                              <li><a ><i class="fa fa-dribbble"></i></a></li>
                                              <li><a href="https://www.facebook.com/runhillAU" target="_blank"><i class="fa fa-facebook"></i></a></li>
                                              
                                          </ul>
                                      </div> 
                                    </div>
                                </div>
                           
                        </div>

                        <div class="col-xl-1 col-lg-1 col-md-1 col-12">
                           <div class="footer__social hidden hidden-sm-and-up mt-10 ml-10" >
                                <ul>
                                    <li><a ><i class="fa fa-dribbble"></i></a></li>
                                    <li><a href="https://www.facebook.com/runhillAU" target="_blank"><i class="fa fa-facebook"></i></a></li>
                                    
                                </ul>
                            </div> 
                            <div class="footer__widget mb-30 hidden-xs-only">
                                <div class="footer__widget-title text-left">
                                    <h5>Pages</h5>
                                </div>
                                <div class="footer__widget-content">
                                    <div class="footer__links text-left">
                                        <ul>
                                            <li @click="urlto(1)" class="active "><a  >HOME </a></li> 
                                            <li @click="urlto(2)" class="" ><a >SHOP</a></li>
                                            <li @click="urlto(3)" class="" ><a >ABOUT</a></li>
                                            <li @click="urlto(4)" class="" ><a target="_blank" href="http://granaryi.com.au">BRANDS</a></li>
                                            <li @click="urlto(5)" class="" ><a >CONTACT</a></li>
                                            <li v-if="login" @click="loginout" class="" ><a >LOGOUT</a></li>
                                            <li v-if="!login" @click="loginnew" class="" ><a >LOGIN</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                       <!--  <div class="col-xl-3 col-lg-3 col-md-3 col-12">
                            <div class="footer__widget mb-30">
                                <div class="footer__widget-title mb-25">
                                    <h5>Customer Service</h5>
                                </div>
                                <div class="footer__widget-content">
                                    <div class="footer__links">
                                        <ul>
                                            <li><a >Shipping Policy</a></li>
                                            <li><a >Help & Contact Us</a></li>
                                            <li><a >Returns & Refunds</a></li>
                                            <li><a >Online Stores</a></li>
                                            <li><a >Terms & Conditions</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="footer__bottom">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-6 col-lg-7">
                            <div class="footer__copyright">
                                <p class="nowarp font-mini">runhill pty ltd &copy; 2022.Granaryi Pty Ltd All Rights Reserved.<a target="_blank" ></a></p>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </section>
  </div>
</template>
<script>
// import { getconfig } from "@/api/index/index";
import { getconcact } from "@/api/index/index";
export default {
  name: "footer",
  data() {
    return {
      config: [],
      addressinfo:[],
      logourlshop:'',
      login:false,
      concact:''
    };
  },
  mounted() {
    console.log(this.login);
    if (sessionStorage.getItem("login")){
        this.login=true
      }else{
        this.login=false
      }
    this.getcof();
  },
  methods: {

    urlto(res) {
      if (res == 3) {
        this.$router.push({ name: "video" });
      } else {
        this.$router.push({ name: "team" });
      }
    },
    // 登出
    loginout(){
        sessionStorage.setItem('login','')
        sessionStorage.setItem('logourlshop','')
        sessionStorage.setItem('concact','')    
        sessionStorage.setItem('shopid','') 
        location. reload()
    },// 登lu
    loginnew(){
      this.$router.push({ name: "login" });
    },
    getcof() {
      
      

      getconcact().then((res)=>{
          this.addressinfo=res.content
          // this.banner=res.banner[0].image
      })    
       if (sessionStorage.getItem("logourlshop") != "" && sessionStorage.getItem("logourlshop") != null) {
        //console.log(sessionStorage.getItem("logourlshop"),'缓存有头像')
        this.logourlshop = sessionStorage.getItem("logourlshop");
      }
       if (sessionStorage.getItem("concact") != "" && sessionStorage.getItem("concact") != null) {
        //console.log(sessionStorage.getItem("logourlshop"),'缓存有头像')
        this.concact = sessionStorage.getItem("concact");
      }
    
      
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
 @import "../assets/css/preloader.css";
    @import "../assets/css/bootstrap.min.css";
    @import "../assets/css/slick.css";
    @import "../assets/css/owl.carousel.min.css";
    @import "../assets/css/animate.min.css";
    @import "../assets/css/jquery.fancybox.min.css";
    
    @import "../assets/css/default.css";
    @import "../assets/css/style.css";
.flex {
  display: flex;
}
.flex-ct {
  justify-content: center;
}
.flex-jb {
  justify-content: space-between;
}

/* .footer {
  width: 100%;
  height: 42vh;
  background-color: #313131;
  position: relative;
}
.footer-box {
  display: flex;
  justify-content: space-between;
  align-content: center;
  flex-wrap: wrap;
  padding-top: 3vh;
}
.companyMes {
  width: 90%;
  margin: 0 auto;
  height: 20vh;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: "AlibabaPuHuiTiB";
}
.title {
  padding-left: 0;
  text-align: left;
  line-height: 4.5vh;
}
.relation {
  margin-left: 5%;
  text-align: left;
  line-height: 5vh;
}
.title > p {
  font-size: 1.4vw;
  padding: 0;
}
.title > h3 {
  font-size: 2.2vw;
  margin: 1vh 0;
}
.relation > p {
  font-size: 1.5vw;
}
.relation > h3 {
  font-size: 2.5vw;
  margin: 1vh 0;
}
.codePic {
  width: 10vw;
}
.introduce {
  margin-left: 3vw;
  width: 90%;
  height: 100%;
  font-size: 1vw;
  text-align: left;
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 2vh;
}
.introduce > div {
  padding: 0 2vw;
}
.introduce > div:first-child {
  border-right: 0.2vh solid #989898;
}
.introduce > div:first-child > p {
  padding: 1vh 0;
  margin: 0;
}
.location {
  line-height: 4vh;
  text-align: left;
}
.remark {
  width: 100%;
  height: 4vh;
  line-height: 4vh;
  font-size: 1vw;
  color: rgba(255, 255, 255, 0.4);
  background-color: #2c2c2c;
} */
.icon_go_wrap {
  position: fixed;
  right: 3%;
  z-index: 1000;
  bottom: 10%;
}
.icon_go_wrap .icon_go {
  width: 32px;
  height: 41px;
  cursor: pointer;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  border: 1px solid #000;
  opacity: 0;
  transition: opacity 0.3s linear;
}
.icon_go_wrap .icon_go.on {
  opacity: 1;
}
.icon_go_wrap #goTop {
  background-image: url("../../public/image/go_top.png");
}
.icon_go_wrap #goBottom {
  margin-top: 1px;
  background-image: url("../../public/image/go_bottom.png");
}

.footer {
  border-top: 1px solid #cac9c5;
  padding: 100px 0 40px;
  margin-top: 100px;
}
.footer a {
  text-decoration: none;
}
.footer a:hover {
  text-decoration: none;
}
.footer .footer-nav {
  padding: 0 19%;
  margin-bottom: 3%;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
}
.footer .footer-nav .footer-nav-col {
  width: auto;
}
.footer .footer-nav .footer-nav-col dt {
  font-size: 18px;
  line-height: 1.5em;
  margin-bottom: 25px;
}
.footer .footer-nav .footer-nav-col dd {
  padding: 12px 0;
}
.footer .footer-nav .footer-nav-col dd a {
  font-size: 14px;
  line-height: 1.5em;
  color: #808080;
}
.footer .footer-nav .footer-nav-col dd a:hover {
  color: #000;
}
.footer .footer-nav .footer-nav-col .show_code {
  display: none;
  position: absolute;
  width: 120px;
  height: 120px;
  bottom: 40px;
  left: -45px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
.footer .footer-nav .footer-nav-col .show_code img {
  display: block;
  width: 100%;
}
.footer .footer-nav .footer-nav-col .show_code:before {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  margin-left: -10px;
}
.footer__contact ul li .icon i{margin-right:10px;width:14px}
.footer .f_msg p {
  font-size: 14px;
  color: #000;
  text-align: center;
}
a{cursor: pointer;}
.footer{padding-bottom:0}
@media screen and (max-width: 768px) {
  .footer__widget-title{text-align: left;}
}

@media screen and (max-width: 480px) {
  .footer__widget-title img{width:33%!important}
  .footer .footer-nav {
    padding: 0 10%;
  }
  .footer .footer-nav .footer-nav-col dt {
    font-size: 12px;
  }
  .footer .f_msg p {
    font-size: 12px;
  }
  .padding480{padding:0 10%}
  .footer__contact ul li .icon i{margin-right:10px;width:14px}
  .fa:before{width:100%}
  .footer a{font-size: 12px;}
  .footer__contact .text span{font-size: 12px;}
  .footer{margin-top:0;padding-top:0}
}
@media screen and (max-width: 35px) {
  .nowarp{white-space: nowrap;}
  .font-mini{font-size: 12px;}
}

.footer .fa{color:#fff}

.footer .footer__social .fa{font-size:20px}
.footlogo img{width:50%}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue